module.exports = __webpack_public_path__ + "img/report.a8791d94.png";